import type { Configuration, PopupRequest } from '@azure/msal-browser';

function getEnvVar(key: keyof ImportMetaEnv): string | undefined {
    const value = import.meta.env[key];
    return value && value.trim().length > 0 ? value : undefined;
}

const CLIENT_ID = getEnvVar('VITE_OAUTH_CLIENT_ID');
const TENANT_ID = getEnvVar('VITE_AZURE_TENANT_ID');

// Use environment variable if available, otherwise construct from current origin
// This ensures it works in both local dev and deployed environments
const REDIRECT_URI =
    getEnvVar('VITE_OAUTH_REDIRECT_URI') ?? `${window.location.origin}/auth/callback`;
const POST_LOGOUT_REDIRECT_URI =
    getEnvVar('VITE_AZURE_POST_LOGOUT_REDIRECT_URI') ?? `${window.location.origin}/signin`;

export const msalConfig: Configuration = {
    auth: {
        clientId: CLIENT_ID ?? '',
        authority: `https://login.microsoftonline.com/${TENANT_ID ?? ''}`,
        redirectUri: REDIRECT_URI,
        postLogoutRedirectUri: POST_LOGOUT_REDIRECT_URI,
    },
    cache: {
        // Use sessionStorage for secure token management
        cacheLocation: 'sessionStorage',
    },
};

export const loginRequest: PopupRequest = {
    scopes: ['openid', 'profile', 'email'],
};

// API scope for backend calls
export const apiRequest: PopupRequest = {
    scopes: CLIENT_ID ? [`api://${CLIENT_ID}/access`] : [],
};

/**
 * Check if MSAL is properly configured.
 */
export function isMsalConfigured(): boolean {
    return !!CLIENT_ID;
}

/**
 * Get configuration error message if not configured.
 */
export function getConfigurationError(): string | null {
    if (!CLIENT_ID) {
        return 'Azure AD Client ID not configured. Please set VITE_OAUTH_CLIENT_ID in your .env file. See README.md for setup instructions.';
    }
    return null;
}
